import { ConditionEvaluator } from '@leverege/condition';
import NumberNotEqualsEvaluator from "../../shared/NumberNotEqualsEvaluator.js";
export default class NumericNotEqualsComparatorEvaluator extends ConditionEvaluator {
  satisfies(context) {
    const {
      attribute,
      target
    } = context;
    const targetValue = attribute?.get(target?.data);
    const value1 = attribute.valueType === 'timestamp' ? new Date(this.model.value1).getTime() : this.model.value1;
    return NumberNotEqualsEvaluator.satisfies(targetValue, value1);
  }
}